const HOST = process.env.VUE_APP_TEST_HOST || '';
// const pyOnlineUlr = process.env.NODE_ENV === 'development' ? 'https://test.xiaohoucode.com' : HOST
export default {
  baseUrl: "/api",
  scratchUrl: `${HOST}/scratch/v3/`,
  mblockUrl: `${HOST}/mblock/`,
  pyUrl: `${HOST}/py-editor/`,
  pythonGame: `${HOST}/xhpython-web/#/competition/game`,
  pythonOnline: `${HOST}/xhpython-web/#/competition/online`,
  pyCmUrl: `${HOST}/wonder-land/`,
  cppUrl: `${HOST}/cpp-editor/`,
  cmUrl: `${HOST}/api/competition/cm/challenge/`,
};


export const communityUrl = {
  scratchUrl: `${HOST}/community/scratch/v3/`,
  pyUrl: `${HOST}/community/py-editor/`,
};
